import React from 'react';
import Image from 'next/image';

interface FeatureRowProps {
  id?: string;
  imageSrc: string;
  imageAlt: string;
  imageAspectRatio?: number;
  title: string;
  children: React.ReactNode;
  imageRight?: boolean;
}

export default function FeatureRow({
  id,
  imageSrc,
  imageAlt,
  imageAspectRatio = 1,
  title,
  children,
  imageRight = false,
}: FeatureRowProps) {
  return (
    <section id={id} className="feature-row-section">
      <div className="page-width">
        <div className={`feature-row ${imageRight ? 'feature-row--reversed' : ''}`}>
          <div className="feature-row__image-col">
            <div
              className="feature-row__image-wrapper"
              style={{ paddingTop: `${(1 / imageAspectRatio) * 100}%` }}
            >
              <Image
                src={imageSrc}
                alt={imageAlt}
                fill
                className="feature-row__image"
                style={{ objectFit: 'cover' }}
                sizes="(max-width: 749px) 100vw, 50vw"
              />
            </div>
          </div>
          <div className="feature-row__text-col">
            <h2 className="feature-row__title">{title}</h2>
            <div className="feature-row__body">{children}</div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .feature-row-section {
          padding: 50px 0;
          font-family: 'Work Sans', sans-serif;
        }
        .page-width {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 30px;
        }
        .feature-row {
          display: flex;
          align-items: center;
          gap: 40px;
        }
        .feature-row--reversed {
          flex-direction: row-reverse;
        }
        .feature-row__image-col {
          flex: 1;
          min-width: 0;
        }
        .feature-row__image-wrapper {
          position: relative;
          width: 100%;
          overflow: hidden;
          border-radius: 2px;
        }
        .feature-row__text-col {
          flex: 1;
          min-width: 0;
          padding: 20px 0;
        }
        .feature-row__title {
          font-size: 26px;
          font-weight: 600;
          color: #3d4246;
          margin: 0 0 16px 0;
          font-family: 'Work Sans', sans-serif;
        }
        .feature-row__body {
          color: #3d4246;
          font-size: 16px;
          line-height: 1.7;
          font-family: 'Work Sans', sans-serif;
        }
        @media (max-width: 749px) {
          .feature-row {
            flex-direction: column;
          }
          .feature-row--reversed {
            flex-direction: column;
          }
          .feature-row__image-col {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
}
